// extracted by mini-css-extract-plugin
export default {"titleContent":"_2Hs6HYXYUgCgbMx7Icd7E9","titleCta":"hGbtfzZg-hn5wESb3jrk1","titleIcon":"_3NuP1C33ylYA-ko7fQ2R7r","dialogPaper":"iGCZwkCTr8_-pNgSOMC3x"};